import * as React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { nftJsonState } from "../states/nftJsonState";

type Props = {
    // imageUrl: string,
}

//nftImage コンポーネントの定義
export const NFTImage: React.FC<Props> = (props) => {
  const nftInfo = useRecoilValue(nftJsonState);

  const NFTImageComponent = styled.img`
      display: unset;
      border-radius: 10px;
      margin-top: 70px;
      margin-bottom: 20px;
      border: 6px solid rgba(255, 255, 255, 0.4);
      
      @media (max-width: 2560px) {
        width: 20%;
        height: 20%;
      }
      @media (max-width: 768px) {
        width: 55%;
        height: 55%;
      }
  `;

  return (
    <div>
        <NFTImageComponent  
          src={`${nftInfo.image}`} 
          alt='NFT_Image'
        />
    </div>
  );
};